import {Injectable} from '@angular/core';

import {File} from '@ionic-native/file';

/*
  Generated class for the FileProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class FileProvider {

  constructor(private file: File) {
    console.log('Hello FileProvider Provider');
  }

  extractName(path) {
    if (path.substr(0, 12) == 'C:\\fakepath\\') {
      // Modern browser
      return path.substr(12);
    }

    var x;
    x = path.lastIndexOf('/');
    if (x >= 0) {
      // Unix-based path
      return path.substr(x + 1);
    }

    x = path.lastIndexOf('\\');
    if (x >= 0) {
      // Windows-based path
      return path.substr(x + 1);
    }

    // Just the name
    return path;
  }

  base64ToBlob(base64, mime) {
    mime = mime || '';
    var sliceSize = 1024;
    var byteChars = window.atob(base64);
    var byteArrays = [];

    for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
      var slice = byteChars.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: mime});
  }

  generateName() {
    let name = '';
    name += Math.floor(Math.random() * 100) + 2 + '';
    name += new Date().getTime() + Math.floor(Math.random() * 100) + 2 + '';
    name += (Math.random().toString(36).replace(/[^a-zA-Z]+/g, '').substr(0, 5));

    return name;
  }

  /**
   * Create a file according to its base64 content.
   *
   * @param path The folder where the file will be created.
   * @param fileName The name of the file that will be created.
   * @param content Important : The content can't contain the following string (data:image/png[or any other format];base64,). Only the base64 string is expected.
   * @param contentType The type of content passed.
   */
  saveBase64AsFile(path: string, fileName: string, content: string, contentType: string): Promise<any> {
    let that = this;

    // Convert the base64 string in a Blob
    var data = this.base64ToBlob(content, contentType);

    // console.log('saveBase64AsFile: Starting to write the file :3');

    return new Promise((resolve, reject) => {
      that.file.resolveLocalFilesystemUrl(path).then((dir) => {
        // console.log('saveBase64AsFile: Access to the directory granted succesfully');
        // console.log(dir);
        // console.log(path);

        // console.log(fileName);
        that.file.writeFile(path, fileName, data, {replace: true}).then(
          res => {
            // resolve(path + res.fullPath);
            resolve(path + fileName);
          },
          error => {
            console.log(error);
            reject(error);
          }
        ).catch(error => {
          console.log(error);
          reject(error);
        });
      }).catch(error => {
        console.log(error);
        reject(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/file/file.ts